import React, { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { generatePin, getAllPins } from "../../../services/Admin";
import CustomTable from "../../components/custom-table/CustomTable";
import Loader from "../../components/loader/Loader";
import Loader2 from "../../components/loader/Loader2";
import "../add-package/style.css";

const PACKAGE_OPTIONS = [0, 10, 50, 100];

function GeneratePins() {
  const [packageType, setPackageType] = useState("");
  const [isPending, setIsPending] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [pins, setPins] = useState([]);

  const columns = useMemo(
    () => [
      { Header: "Pin", accessor: "pin" },
      { Header: "Package Type ($)", accessor: "packageType" },
      { Header: "Source", accessor: "source" },
      { Header: "Status", accessor: "status" },
      { Header: "Used By", accessor: "usedBy" },
      { Header: "Created At", accessor: "createdAt" },
    ],
    []
  );

  const fetchPins = async () => {
    setIsLoading(true);
    try {
      const res = await getAllPins();
      const rows = (res.data || []).map((p) => ({
        pin: p.pin,
        packageType: `$${p.packageType}`,
        // Pins bought on CGT Homes carry the buyer's email; admin-made ones don't.
        source: p.source === "CGTHomes" ? `CGT Homes (${p.issuedTo || "—"})` : "Admin",
        status: p.activated ? "Activated" : "Available",
        usedBy: p.usedBy || "-",
        createdAt: p.createdAt ? new Date(p.createdAt).toLocaleString() : "-",
      }));
      setPins(rows);
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Failed to fetch pins");
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchPins();
  }, []);

  const handleGeneratePin = async () => {
    if (!packageType) {
      toast.warn("Please select a package type!");
      return;
    }
    setIsPending(true);
    try {
      const res = await generatePin(Number(packageType));
      const newPin = res?.data?.pin;
      toast.success(`Pin generated: ${newPin}`);
      setPackageType("");
      fetchPins();
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Failed to generate pin");
    }
    setIsPending(false);
  };

  return (
    <div className="deposit">
      <h1 className="main-heading">Generate Hybrid Pins</h1>

      {isPending && <Loader2 />}

      <div className="adpa-first">
        <div className="adpafi-top">
          <h2>Generate a New Pin</h2>
        </div>
        <div className="adpafi-body">
          <div className="input-group">
            <label>Select Package Type ($)</label>
            <select
              name="packageType"
              value={packageType}
              onChange={(e) => setPackageType(e.target.value)}
            >
              <option value="">--Select Package--</option>
              {PACKAGE_OPTIONS.map((amount) => (
                <option key={amount} value={amount}>
                  ${amount}
                </option>
              ))}
            </select>
          </div>
          <div className="button-group">
            <button type="button" onClick={handleGeneratePin}>
              Generate Pin
            </button>
          </div>
        </div>
      </div>

      <div className="investment-history" style={{ marginTop: "1.5rem" }}>
        {isLoading ? (
          <Loader />
        ) : (
          <CustomTable data={pins} columns={columns} heading="Generated Pins" />
        )}
      </div>
    </div>
  );
}

export default GeneratePins;
